<template>
    <div id="addTypes">
        <el-card shadow="never">
            <el-row>
                <el-col :span="10" :offset="1">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        status-icon
                        label-width="100px"
                    >
                        <el-form-item label="地点编号" prop="locationCode">
                            <el-input
                                v-model="ruleForm.locationCode"
                                placeholder="请输入地点编号"
                                :disabled="disabled"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="地点名称" prop="description">
                            <el-input
                                v-model="ruleForm.description"
                                placeholder="请输入地点名称"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="免费招待" prop="complimentary">
                            <!-- <el-input v-model="ruleForm.complimentary" placeholder="请输入类型名称"></el-input> -->
                            <el-radio
                                v-model="ruleForm.complimentary"
                                :disabled="disabled"
                                label="Y"
                                >是</el-radio
                            >
                            <el-radio
                                v-model="ruleForm.complimentary"
                                :disabled="disabled"
                                label="N"
                                >否</el-radio
                            >
                            <el-radio
                                v-model="ruleForm.complimentary"
                                :disabled="disabled"
                                label=""
                                >不选</el-radio
                            >
                        </el-form-item>

                        <el-form-item label="优惠" prop="discount">
                            <el-radio
                                v-model="ruleForm.discount"
                                :disabled="disabled"
                                label="Y"
                                >是</el-radio
                            >
                            <el-radio
                                v-model="ruleForm.discount"
                                :disabled="disabled"
                                label="N"
                                >否</el-radio
                            >
                            <el-radio
                                v-model="ruleForm.discount"
                                :disabled="disabled"
                                label=""
                                >不选</el-radio
                            >
                        </el-form-item>

                        <el-form-item>
                            <p>注意:免费招待和优惠只能选择一个！</p>
                        </el-form-item>

                        <el-form-item class="submit">
                            <el-button
                                type="primary"
                                @click="submitForm('ruleForm')"
                                >保存</el-button
                            >
                            <el-button @click="cancel()">返回</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
.submit {
    margin-top: 20px;
}
</style>
<script>
import axios from '../../env/axios'
import apis from '../../env/apis'
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
export default {
    mixins: [requestMixin, common],
    inject: ['reload'],
    data () {
        return {
            disabled: false,
            ruleForm: {
                locationCode: '',
                description: '',
                complimentary: '',
                discount: ''
            },
            rules: {
                locationCode: [
                    { required: true, message: '请输入地点类型编号', trigger: "blur" },
                    { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
                ],
                description: [
                    { required: true, message: '请输入地点类型名称', trigger: 'blur' },
                    { min: 1, max: 100, message: '长度在3到100个字符', trigger: 'blur' }
                ]
            },
        }
    },
    mounted () {
        let index = this.$route.query.index;
        if (index != undefined) {
            this.$nextTick(() => {
                this.reviseLocation();
            })
        }
    },
    watch: {
        //监听直接userid转大写
        'ruleForm.locationCode': {
            deep: true,
            handler: function (newVal, oldVal) {
                newVal = newVal.toUpperCase();
                this.ruleForm.locationCode = newVal;
            }
        }
    },
    methods: {
        /**
         * 保存，提交按钮
         */
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                 
                    let { locationCode, description, complimentary, discount } = this.ruleForm;
                    let userId = sessionStorage.getItem("userId") ;
                     locationCode=locationCode.trim();
                    let params;
                    if (discount && complimentary && this.$route.query.index!=0) {
                        this.alert('免费招待和优惠只能选择一个！', 'warning');
                        return;
                    } else if (discount && !complimentary) {
                        params = {
                            act: 'addLocation',
                            code: locationCode,
                            description,
                            discount,
                            userId
                        }
                    }else if(!discount && complimentary){
                        params = {
                            act: 'addLocation',
                            code: locationCode,
                            description,
                            complimentary,
                            userId
                        }
                    }else if(!discount && !complimentary){
                        this.alert('免费招待和优惠必须选择一个！', 'warning');
                        return;
                    }
                    let index = this.$route.query.index;
                    if (index != undefined) {
                        params = {
                            act: 'updateLocation',
                            code: locationCode,
                            description,
                            complimentary,
                            userId
                        }
                       // params.act = "updateLocation"
                        this.delType(params).then((res) => {
                            if (res.data.status == true) {
                                this.$message({
                                    type: 'success',
                                    message: '更新成功 √ '
                                });
                                this.$router.push({ path: '/system/location' })
                            } else {
                                this.$alert(res.data.msg, '提示', {
                                    confirmButtonText: '确定',
                                    type: 'warning',
                                    center: true
                                });
                            }
                        })
                    } else {
                        this.addLocation(params).then((res) => {
                            if (res.data.status == true) {
                                this.$confirm('添加成功', '提示', {
                                    confirmButtonText: '确定',
                                    showCancelButton: false,
                                    type: 'success'
                                }).then(() => {
                                    //确定 - 刷新表单
                                    this.reload();
                                }).catch(() => {
                                    this.promptMsg('已取消', 'info');
                                })
                            } else {
                                this.$alert(res.data.msg, '提示', {
                                    confirmButtonText: '确定',
                                    type: 'warning',
                                    center: true
                                });
                            }
                        })
                    }


                } else {
                    return false;
                }
            });
        },

        /**
         * 添加地点
         */
        async addLocation (params) {
            let result;
            await axios.post(apis.baseURL, params)
                .then((res) => {
                    result = res
                })
                .catch((error) => {
                    this.$message({
                        showClose: true,
                        message: '数据请求错误',
                        type: 'error'
                    });
                })
            return result;
        },

        /**
         * 取消按钮
         */
        cancel () {
            this.$router.go(-1)
        },

        /**
         * 修改用户信息
        */
        reviseLocation () {
            let index = this.$route.query.index;
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act: "findLocations",
                userId
            }
            this.findType(params).then((res) => {
                // console.log(res)
                if (res.data.status == true) {
                    let result = res.data.list;
                    this.disabled = true;
                    //this.sortChinese(result,"description");
                    this.ruleForm = result[index];
                } else {
                    this.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        center: true,
                        type: 'error'
                    })
                }
            })
        },
    }
}
</script>
